import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import AssessmentProgressView from "../components/AssessmentProgressView";
import achievementTypes from "../../../constants/achievement-types";
import AchievementView from "../components/AchievementView";
import AssessmentDetailView from "../components/AssessmentDetailView";
import AchievementDetailView from "../components/AchievementDetailView";
class AssessmentStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType) {
    super(story, me, viewType);
  }
  getStoryDate = () => {
    return this.story.story.da;
  };
  addContentViewModel = (parts, handler) => {
    let meta = this.story.story;
    let measure;
    if (meta.me % 1 !== 0) {
      measure = meta.me.toFixed(2);
    } else {
      measure = meta.me.toString();
    }
    let line = `${meta.na} : ${measure}`;
    parts.push({
      type: AssessmentDetailView,
      props: {
        line: line,
        assessment: meta.na,
        measure: measure,
        goal: meta.go,
        paddingTop: 10,
        paddingBottom: 10,
        id: this.story.story_id,
      },
      key: `as-m-${this.story.story_id}`,
    });
    if (meta.pr) {
      parts.push({
        type: AssessmentProgressView,
        props: {
          progress: meta.pr,
        },
        key: `as-pr-${this.story.story_id}`,
      });
    }
    if (meta.go) {
      if (meta.go.pc < 100) {
        // parts.push({
        //   type: GoalView,
        //   props: {
        //     goal: meta.go
        //   },
        //   key: `as-gp-${this.story.story_id}`
        // });
      } else {
        parts.push({
          type: AchievementDetailView,
          props: {
            workout: [],
            achievements: [
              {
                type: achievementTypes.GOAL_UNLOCKED,
                ta: meta.go.ta,
              },
            ],
          },
          key: `as-gu-${this.story.story_id}`,
        });
      }
    }
  };
}
export default AssessmentStoryViewModel;
